module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_c('clipPath', [_c('path', {
    attrs: {
      "d": "m0 0h313.41v511h-313.41z"
    }
  })]), _c('g', [_c('path', {
    attrs: {
      "d": "m301.08 129.71v108.18h-.29c-5.1-4-11.55 7.45-19 7.45a31.39 31.39 0 0 0 -4.85.35h-240.44a31.3 31.3 0 0 0 -4.84-.35c-6.72 0-12.6-11.93-17.43-8.64v-140.51a34 34 0 0 1 44-32.45 90.89 90.89 0 0 1 118.59-58l1.38.52 52.68 20.64a110.39 110.39 0 0 1 70.19 102.81",
      "fill": "#f7d360"
    }
  }), _c('path', {
    attrs: {
      "d": "m101 79c0 36.55 29.67 77.18 29.67 77.18l-27.37 75.68-66.8 13.83a31.31 31.31 0 0 0 -4.84-.35c-6.72 0-12.6-11.93-17.43-8.64v-140.51a34 34 0 0 1 44-32.45 90.89 90.89 0 0 1 118.59-58c-40.09-14.33-75.82 37.13-75.82 73.26",
      "fill": "#e58e13"
    }
  }), _c('path', {
    attrs: {
      "d": "m287.56 511h-261.73l13.57-51.93 82.85-48.03h68.89l82.85 48.03z",
      "fill": "#c9fff7"
    }
  }), _c('path', {
    attrs: {
      "d": "m164.53 423.89v87.11h-15.67v-87.11a7.83 7.83 0 0 1 15.66 0",
      "fill": "#72cec0"
    }
  }), _c('path', {
    attrs: {
      "d": "m216.19 425.55-11.12 55.45-48.36-35.5-48.39 35.5-11.1-55.45 25.03-14.51h68.91z",
      "fill": "#72cec0"
    }
  }), _c('path', {
    attrs: {
      "d": "m191.17 372v39a34.44 34.44 0 0 1 -34.46 34.46 34.45 34.45 0 0 1 -34.46-34.46v-39z",
      "fill": "#e8b094"
    }
  }), _c('path', {
    attrs: {
      "d": "m191.17 396.63v14.37a34.46 34.46 0 0 1 -22.71 32.4 34.45 34.45 0 0 1 -22.71-32.4v-9.9q5.4.5 11 .5a120.34 120.34 0 0 0 34.47-5",
      "fill": "#ffdbcc"
    }
  }), _c('path', {
    attrs: {
      "d": "m276.9 231.86a31.39 31.39 0 0 1 4.85-.35c19.21 0 31.66 15.57 31.66 34.78s-17.91 45.46-37.12 45.46a17.43 17.43 0 0 1 -10.89-3.6h-217.4a17.43 17.43 0 0 1 -10.89 3.6c-19.2 0-37.11-26.25-37.11-45.46s12.45-34.78 31.66-34.78a31.32 31.32 0 0 1 4.84.35",
      "fill": "#e8b094"
    }
  }), _c('path', {
    attrs: {
      "d": "m40 293.48a7.83 7.83 0 0 1 -7.62-6.05c-1.45-6.09-6.38-17.43-11.77-17.43a7.83 7.83 0 1 1 0-15.66c19.58 0 26.31 26.55 27 29.58a7.83 7.83 0 0 1 -5.85 9.4 7.73 7.73 0 0 1 -1.78.21",
      "fill": "#db9784"
    }
  }), _c('path', {
    attrs: {
      "d": "m273.41 293.48a7.71 7.71 0 0 1 -1.78-.21 7.83 7.83 0 0 1 -5.86-9.4c.7-3 7.43-29.58 27-29.58a7.83 7.83 0 1 1 0 15.66c-5.38 0-10.39 11.56-11.76 17.46a7.83 7.83 0 0 1 -7.62 6.06",
      "fill": "#db9784"
    }
  }), _c('path', {
    attrs: {
      "d": "m65.62 111c68.81 74.91 211.29 78 211.29 78v67.8a120.2 120.2 0 0 1 -240.4 0v-67.39a119.69 119.69 0 0 1 29.11-78.41z",
      "fill": "#ffdbcc"
    }
  }), _c('path', {
    attrs: {
      "d": "m77 256.8v-67.39a119.61 119.61 0 0 1 13.86-56.08 168.84 168.84 0 0 1 -25.24-22.33 119.68 119.68 0 0 0 -29.12 78.41v67.39a120.27 120.27 0 0 0 140.5 118.49 120.23 120.23 0 0 1 -100-118.49",
      "fill": "#e8b094"
    }
  }), _c('path', {
    attrs: {
      "d": "m87.89 217.06a7.83 7.83 0 0 1 -1.89-15.42l35.5-9a7.83 7.83 0 0 1 3.87 15.18l-35.5 9a7.94 7.94 0 0 1 -1.94.25",
      "fill": "#e58e13"
    }
  }), _c('path', {
    attrs: {
      "d": "m225.51 217.06a7.94 7.94 0 0 1 -1.94-.25l-35.5-9a7.83 7.83 0 0 1 3.87-15.18l35.51 9a7.83 7.83 0 0 1 -1.93 15.42",
      "fill": "#e58e13"
    }
  }), _c('path', {
    attrs: {
      "d": "m110.06 250.82a7.83 7.83 0 0 1 -7.83-7.83v-8.7a7.83 7.83 0 0 1 15.67 0v8.71a7.83 7.83 0 0 1 -7.83 7.83",
      "fill": "#3b454f"
    }
  }), _c('path', {
    attrs: {
      "d": "m203.34 250.82a7.83 7.83 0 0 1 -7.83-7.83v-8.7a7.83 7.83 0 1 1 15.66 0v8.71a7.83 7.83 0 0 1 -7.83 7.83",
      "fill": "#3b454f"
    }
  }), _c('g', {
    attrs: {
      "fill": "#db9784"
    }
  }, [_c('path', {
    attrs: {
      "d": "m156.7 282.44a25.45 25.45 0 0 1 -18.05-7.44 7.83 7.83 0 1 1 11.08-11.08 9.89 9.89 0 0 0 14 0 7.83 7.83 0 0 1 11.03 11.08 25.44 25.44 0 0 1 -18.05 7.47"
    }
  }), _c('path', {
    attrs: {
      "d": "m148.18 330.47a8.19 8.19 0 0 1 -.87 0c-37.5-4.12-46.14-31.45-46.49-32.62a7.83 7.83 0 0 1 15-4.58c.3.92 6.51 18.69 33.23 21.63a7.83 7.83 0 0 1 -.85 15.61"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ab709d","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/boy/MentoringBoyIcon.vue
// module id = a224d05f56113438f82b
// module chunks = 89